import axios from "axios";

type setProps = {
    loginId: string;
    makeupId: string;
    eventJoinId: string;
    rotaryCd: string;
}


/**
 * d_event_joinにメークアップIDを登録するAPI
 */

export async function setMakeUpId(props: setProps){
    try{
        //  API呼出し
        const response = await axios.put(process.env.REACT_APP_PATH + `//makeup/set-eventjoin`, null, {
            params: {
                loginId: props.loginId,
                makeupId: props.makeupId,
                eventJoinId: props.eventJoinId,
                rotaryCd: props.rotaryCd
            }
        })
        return response

    }catch(error){
        console.warn(error)
    }
}